import { render, staticRenderFns } from "./LabelManager.vue?vue&type=template&id=3e885fdb"
import script from "./LabelManager.vue?vue&type=script&lang=js"
export * from "./LabelManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports